export default Object.freeze([
    {
        name: 'Left',
        value: 'Left'
    },
    {
        name: 'Right',
        value: 'Right'
    }
]);
